import { render, staticRenderFns } from "./MerchantExtended.vue?vue&type=template&id=9a45a0f6&scoped=true"
import script from "./MerchantExtended.vue?vue&type=script&lang=js"
export * from "./MerchantExtended.vue?vue&type=script&lang=js"
import style0 from "./MerchantExtended.vue?vue&type=style&index=0&id=9a45a0f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a45a0f6",
  null
  
)

export default component.exports